// 24×24 line icons for the build steps, drawn with stroke="currentColor".
export default {
  framesets: 'M2 17L8 6L11 17Z M8 6L19 7 M19.5 10L11 17 M19 7L21 17 M8 6L7.5 4',
  bars: 'M4 9H20 M6 9C6 14 8 16 10 16 M18 9C18 14 16 16 14 16 M12 9V5',
  groupsets: 'M12 4A7 7 0 1 1 11.99 4Z M12 9.5A1.5 1.5 0 1 1 11.99 9.5Z M13 12.5L17 20 M16 20H19',
  wheels: 'M12 4A8 8 0 1 1 11.99 4Z M12 10.5A1.5 1.5 0 1 1 11.99 10.5Z M12 4V10.5 M12 13.5V20 M4 12H10.5 M13.5 12H20 M6.3 6.3L10.9 10.9 M13.1 13.1L17.7 17.7 M17.7 6.3L13.1 10.9 M10.9 13.1L6.3 17.7',
  tyres: 'M12 3A9 9 0 1 1 11.99 3Z M12 6.5A5.5 5.5 0 1 1 11.99 6.5Z M12 3V6.5 M12 17.5V21 M3 12H6.5 M17.5 12H21 M5.6 5.6L8.1 8.1 M15.9 15.9L18.4 18.4 M18.4 5.6L15.9 8.1 M8.1 15.9L5.6 18.4',
  seatposts: 'M7 4H16 M11.5 4L12.5 21 M10 8.5H12',
  saddles: 'M3 10C7 8 12 8 15 9L21 10.5C20 12 17 12.5 14 12.5L10 14H6C4 14 3 12 3 10Z M10 14V20',
  cages: 'M9 8H15V20A1 1 0 0 1 14 21H10A1 1 0 0 1 9 20Z M10 8V5H14V8 M11 3H13 M9 12H15',
  pedals: 'M5 8.5H19V15.5H5Z M2 12H5 M9 8.5V15.5 M15 8.5V15.5',
  fit: 'M12 4A3 3 0 1 1 11.99 4Z M6 20C6 16.5 8.7 13.5 12 13.5S18 16.5 18 20'
};
